export const menuData = [
  //{ to: '/', name: 'store', exact: false },
  // { to: '/product', name: 'product', exact: false },
  { to: '/about-us', name: 'About Us', exact: false },
];

export const mobileMenuData = [
  { to: '/login', name: 'Login', exact: false },
];
